import cookie from 'js-cookie'
import { COOKIE_PREFERENCES_DEPARTURE_AIRPORTS } from '../application/constants'

const setPreferencesInCookie = (airports) => {
  cookie.set(
    COOKIE_PREFERENCES_DEPARTURE_AIRPORTS,
    airports.filter((a) => a.selected).map((a) => a.id),
    { expires: 720 }
  )
}

export { setPreferencesInCookie }
